define(
    'views/foundation.view',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'text!templates/foundation.html',
        'text!templates/foundations_select.html',
        'text!templates/foundation_link.html',
        'text!templates/ajax_loader.html'
    ],
    function(Loader, Config, Helper, Sandbox, foundationTemplate, foundationsTemplate, foundationLinkTemplate, ajaxLoaderTemplate)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var FoundationView = Loader.Backbone.View.extend(
            {

                logs: null,

                events: Helper.prepareEventsForDevice(
                    {
                        //'click #hann h1 span': alert
                    },
                    Loader.eventType
                ),

                routes: {
                    "*": "insertLink",
                    "/mod/foundation$": "foundation",
                    "/mod/foundation/$": "foundation",
                    "/foundation.php": "foundationCredits",
                    "/mod/foundation/points": "foundationPoints",
                    "/mod/foundation/credits": "redirectToCredits"
                },

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render');

                    this.model.on('startApplication', function(){
                        Config.modules.foundation.enabled && Helper.filterRoutes(_this.routes, _this);
                    });
                    this.model.get('forum').on('change:balance', function(){
                        _this.render();
                    });
                    this.undelegateEvents(this.events);
                    this.delegateEvents(this.events);
                },

                render: function(global)
                {
                    if (global) return this;

                    var _this = this;
                    var compiledTemplate = _.template(
                        foundationTemplate,
                        {
                            model: _this.model.toJSON(),
                            user: _this.model.get('users').getMe(),
                            logs: _this.logs,
                            Helper: Helper,
                            Config: Config,
                            ajaxLoaderTemplate: ajaxLoaderTemplate,
                            _:_
                        }
                    );
                    this.$el.html(compiledTemplate);
                    return this;
                },

                insertLink: function()
                {
                    var elem = $("#pun-status p span.item3");

                    if (Config.modules.foundation.type == "points") {
                        var compiledTemplate = _.template(
                            foundationLinkTemplate,
                            {
                                model: this.model.toJSON()
                            }
                        );

                        elem.html(compiledTemplate);
                        elem.show();
                    }
                    else {
                        elem.show();
                    }
                    return this;
                },

                foundation: function()
                {

                    this.model.get('breadcrumbs').setCrumbs({
                        '': 'Фонд форума'
                    });

                    $('#pun-mod').addClass('mod-foundation');

                    var _this = this;
                    var compiledTemplate = _.template(
                        foundationsTemplate,
                        {
                            model: _this.model.toJSON(),
                            user: _this.model.get('users').getMe(),
                            Helper: Helper,
                            Config: Config,
                            _:_
                        }
                    );
                    this.$el.html(compiledTemplate);
                },

                foundationCredits: function()
                {
                    if (Config.modules.foundation.type == "points") {
                        this.model.get('breadcrumbs').setCrumbs({
                            '/mod/foundation': 'Фонд форума',
                            '': 'Кредиты'
                        });
                    }

                    $('#pun-mod').addClass('mod-foundation').addClass('mod-credits-foundation');

                },

                foundationPoints: function(data)
                {
                    var _this = this;

                    this.render();

                    $('#pun-mod').addClass('mod-foundation').addClass('mod-points-foundation');

                    this.model.get('breadcrumbs').setCrumbs({
                        '/mod/foundation': 'Фонд форума',
                        '': 'Баллы'
                    });

                    this.model.get('foundation').getData(function(logs){
                        _this.logs = logs;
                        _this.render();
                    });

                    _this.model.get('forum').getBalance();
                },

                ajaxLoader: function()
                {
                    this.$el
                        .css({"visibility":"visible"})
                        .html(ajaxLoaderTemplate);
                    return this;
                },

                redirectToCredits: function()
                {
                    location.href = '/foundation.php';
                }
            });

        return {
            initialize: function(model)
            {
                return new FoundationView({
                    el: $("#pun-main"),
                    model: model
                })
            }
        }
    }
);

